import hasWindow from '../utils/hasWindow';

const ROOT_URL = hasWindow()
  ? `${window.location.protocol}//${window.location.hostname}${
      window.location.hostname === 'localhost' ? `:${window.location.port}` : ''
    }`
  : '';

export default ROOT_URL;
